import React, { useEffect, useRef, useState } from 'react';

export default function InstallApp() {
  const [prompt, setPrompt] = useState(null);
  const [open, setOpen] = useState(false);
  const [installed, setInstalled] = useState(false);
  const closeRef = useRef(null);
  const triggerRef = useRef(null);
  useEffect(() => {
    setInstalled(window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true);
    const offer = (event) => { event.preventDefault(); setPrompt(event); };
    const done = () => { setInstalled(true); setOpen(false); setPrompt(null); };
    window.addEventListener('beforeinstallprompt', offer);
    window.addEventListener('appinstalled', done);
    return () => { window.removeEventListener('beforeinstallprompt', offer); window.removeEventListener('appinstalled', done); };
  }, []);
  useEffect(() => {
    if (!open) return;
    closeRef.current?.focus();
    const key = (event) => {
      if (event.key === 'Escape') setOpen(false);
      if (event.key === 'Tab') {
        const buttons = [...closeRef.current.closest('[role="dialog"]').querySelectorAll('button')];
        if (event.shiftKey && document.activeElement === buttons[0]) { event.preventDefault(); buttons.at(-1).focus(); }
        else if (!event.shiftKey && document.activeElement === buttons.at(-1)) { event.preventDefault(); buttons[0].focus(); }
      }
    };
    document.addEventListener('keydown', key);
    return () => { document.removeEventListener('keydown', key); triggerRef.current?.focus(); };
  }, [open]);
  const install = async () => {
    if (!prompt) return;
    try { await prompt.prompt(); await prompt.userChoice; } finally { setPrompt(null); setOpen(false); }
  };
  if (installed) return null;
  return <>
    <button className="app-install-button" ref={triggerRef} type="button" onClick={() => setOpen(true)}>Install Cosmos-Station</button>
    {open && <div className="app-install-overlay" onClick={(event) => { if (event.target === event.currentTarget) setOpen(false); }}>
      <section className="app-install-dialog" role="dialog" aria-modal="true" aria-labelledby="app-install-title">
        <button ref={closeRef} className="app-install-close" type="button" aria-label="Close install instructions" onClick={() => setOpen(false)}>×</button>
        <img src="/cosmos-station-mark.svg" alt="" />
        <h2 id="app-install-title">Cosmos-Station on your device</h2>
        <p>Add Cosmos-Station to your home screen or desktop and open it as an app. Live network data needs an internet connection.</p>
        {prompt ? <button type="button" className="app-install-primary" onClick={install}>Install app</button> : <>
          <p><strong>iPhone or iPad</strong><br />Open this site in Safari, tap Share, then Add to Home Screen. Enable Open as Web App if shown.</p>
          <p><strong>Android</strong><br />Open in Chrome, then use the browser menu’s Install app or Add to Home screen option.</p>
          <p><strong>Desktop</strong><br />In Chrome or Edge, use the install icon in the address bar or the browser’s app installation menu.</p>
        </>}
      </section>
    </div>}
  </>;
}
